<template>
    <b-card no-body class="mb-0">
      <b-row v-show="false" class="p-2 pt-3 pb-3">
        <b-col cols :md=6>
          <h5>1. Select Project</h5>
          <b-form-select
            v-model="projectID"
            :options="projects"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            >
          </b-form-select>
        </b-col>
        <b-col v-if="project_ != null" cols :md=6>
          <h5>2. Select File Type</h5>
          <b-form-select
            v-model="meta_"
            :options="metas"
            value-field="value"
            text-field="text"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            >
          </b-form-select>
        </b-col>
      </b-row>

      <b-tabs v-if="raw_file != null && segment != null" card nav-class="pt-3 pl-2" class="tabs" v-model="tab" :key="raw_file['_id']">
        <b-row class="mt-3 mb-4">
          <b-col :cols="2"></b-col>
          <b-col :cols="8" class="text-center">
            <h4 style="color: #49a8e8">
              Segment: <strong style="color: #fff">{{segment.name}}</strong> 
            </h4>
            <h5 style="color: #49a8e8">
              File: <strong style="color: #fff">{{raw_file['originalName']}}</strong>
              <!-- <p v-if="!!this.start_date && !!this.end_date"><strong>Report period:</strong> {{prettifySelectedPeriod(this.start_date, this.end_date)}}</p> -->
            </h5>
          </b-col>
          <b-col :cols="2"></b-col>
        </b-row>

        <b-row>
          <b-col :cols="6">
            <!-- <div class="column"> -->
            <b-card-group deck v-if="!!project_" class="m-2">
              <b-card class="" header-tag="header" footer-tag="footer" style="width: 250px;">
                <template v-slot:header>
                  <h6 class="mb-0 text-center" :id="project_.id">Project Information</h6>
                  <b-tooltip :target="project_.id" placement="bottom">
                    Basic details on project: {{project_.name}}
                  </b-tooltip>
                </template>
                <!-- <b-card-text>Header and footers using slots.</b-card-text> -->
                <template>
                  <b-button v-b-toggle.collapse-1 size="sm" variant="info" style="float: right" 
                    @click="toggleProjectFiles()">
                    Show/Hide Project Files
                  </b-button>
                  <span><strong style="color: #49a8e8">Description:</strong> {{project_.description}}</span><br/>
                  <!-- 
                    <span><strong style="color: #49a8e8">Description:</strong> {{project_.description}}</span><br/> -->
                  <b-collapse id="collapse-1" class="mt-2">
                    <b-table striped hover :items="projectFiles" :v-show="showProjectFiles" :fields="['type', 'file']"></b-table>
                  </b-collapse>
                </template>
              </b-card>
            </b-card-group>
          </b-col>
          <b-col :cols="6">
            <!-- <div class="column"> -->
            <b-card-group deck v-if="!!project_" class="m-2">
              <b-card class="text-center" header-tag="header" footer-tag="footer" style="width: 250px;">
                <template v-slot:header>
                  <h6 class="mb-0" :id="raw_file.id">
                    File Information
                  </h6>
                  <b-tooltip :target="raw_file.id" placement="bottom">
                    Basic details on file: {{raw_file['originalName']}}
                  </b-tooltip>
                </template>
                <!-- <b-card-text>Header and footers using slots.</b-card-text> -->
                <template>
                  <!-- <div v-if="typeof summary.sumdata.chart_data.data === 'number'" class="h4 m-0 p-0 text-center">
                    <b-col style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(summary.sumdata.chart_data.data, 1)}}</b-col>
                  </div> -->
                  <div class="h4 m-0 p-0 text-center">
                    <b-row style="font-size: 15px">
                      <b-col style="color: #B0B0B0">
                        Records
                      </b-col>
                      <b-col style="color: #B0B0B0">
                        Size
                      </b-col>
                      <b-col style="color: #B0B0B0">
                        Date created
                      </b-col>
                    </b-row>
                    <b-row style="font-size: 20px">
                      <b-col style="color: #20A8D8">
                        <i v-if="collection_count == null" class="fa fa-spinner fa-spin"/>
                        <count-to v-else :start-val="0" :end-val="collection_count" :duration="2000"/>
                      </b-col>
                      <b-col style="color: #20A8D8">
                        {{ abbreviateNumber(raw_file.size, 2, true) }}B
                      </b-col>
                      <b-col style="color: #fff; font-size: 14px">
                        <span>{{formatDate(raw_file.createdAt)}}</span>
                      </b-col>
                    </b-row>
                  </div>
                  <!-- <div v-else class="h4 m-0 p-0 text-center">
                    <b-col style="font-size: 35px">{{abbreviateNumber(summary.sumdata.chart_data.data, 1)}}</b-col>
                  </div> -->
                </template>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>

        <b-row :v-hide="false">
          <b-col :cols="2"></b-col>
          <b-col :cols="8" class="text-center">
            <div class="px-3">
              <div class="h4 m-0 p-0">
                <!-- <i v-if="collection_count == null" class="fa fa-spinner fa-spin"/>
                <count-to v-else :start-val="0" :end-val="collection_count" :duration="2000"/> -->
              </div>
              <!-- <div>{{raw_file['originalName'].replace("_", " ").toUpperCase()}}</div> -->
            </div>
          </b-col>
          <b-col :cols="2"></b-col>
        </b-row>

        <conditional-tab :status="true" class="m-2">
          <insights
            :segment-i-d="segmentID"
            :project-i-d="projectID"
            :meta="meta_"
            :raw-file="raw_file"
            :data-type="raw_file['originalName']"
            :database="raw_file['database']"
            :active="true" />
        </conditional-tab>

      </b-tabs>
    </b-card>
</template>

<script>
  import LoansTab from '../Insights/LoansTab';
  import DynamicRules from '../Insights/DynamicRules';
  import ConditionalTab from '../Insights/ConditionalTab';
  import CustomersTab from '../Insights/CustomersTab';
  import TransactionsTab from '../Insights/TransactionsTab';
  import ConditionalSection from '../Insights/ConditionalSection';
  import FilterInput from '../Insights/FilterInput';
  import Insights from "../Insights/Insights";
  import KeyInsights from "../Insights/KeyInsights";
  import ObjectHash from "object-hash";
  import {fetchInsight} from '../Insights/utils';
  import {user} from '../../store/general';
  import moment from "moment";

  export default {
    name: 'SegmentInsights',

    components: {
      LoansTab,
      DynamicRules,
      ConditionalTab,
      Insights,
      CustomersTab,
      TransactionsTab,
      ConditionalSection,
      FilterInput,
      KeyInsights
    },

    // props: {
    //   segmentID: String
    // },

    data() {
      console.log("Projects: ", this.$store.state.files.projectList);
      console.log("Files: ", this.$store.state.files.fileList);
      console.log("User: ", this.$store.state.general.metas);
      const C = this.$store.state.files.collections;
      const KI = this.$store.state.files.keyInsightIds;
      const F = this.$store.state.files.fileList;
      const PL = this.$store.state.files.projectList;
      const user = this.$store.state.user;
      return {
        tab: 0,
        dataStatus: C.reduce((m, k) => ({...m, [k]: null}), {}),
        kiDataStatus: KI.reduce((m, k) => ({...m, [k]: null}), {}),
        segmentID: this.$route.params.id,
        // segment: null,
        C: C,
        F: F,
        PL: PL,
        KI: KI,
        database_: "sfl_app_5_data", // F[0].database,
        projectID: this.$route.params.projectID,
        project_: null,
        meta_: this.$route.params.meta,
        collection_: null,
        raw_file: null,
        collection_count: null,
        showProjectFiles: false,
        idList: [],
        kiCount: KI.length,
        filter: {
          method: "dynamic",
          values: {
            filters: [],
            logic: "and"
          }
        }
      };

    },

    mounted() {
      if (!!this.projectID) {
        this.raw_file = null;
        this.project_ = this.getSelectedProject();
      }
    },

    computed: {
      segment() {
        var segment = this.getSegment(this.segmentID);
        console.log("Segment: ", segment);
        this.$store.state.files.fileList.forEach(file => {
          if (file.database === segment.database && file.id === segment.collection) {
              this.raw_file = file;
              this.database_ = file.database;
              this.getCount();
          }
        });
        return segment;
      },

      metas() {
        var metas = [];
        var projectMetas = [];
        if (!!this.project_ && !!this.project_.files && Object.keys(this.project_.files).length > 0) {
          projectMetas = Object.keys(this.project_.files);
        }
        this.$store.state.general.metas.forEach(meta => {
          if (projectMetas.length === 0) {
            metas.push({'value': meta.type, 'text': meta.name});
          } else {
            if (projectMetas.indexOf(meta.type) > -1) {
              metas.push({'value': meta.type, 'text': meta.name});
            }
          }
        });
        return metas;
      },

      projects(){
        //  return this.$store.state.files.collections;
        var projects = [];
        this.$store.state.files.projectList.forEach(project => {
          var p = {'value': project.id, 'text': project.name};
          if (!projects.includes(p)) {
            projects.push(p);
          }
        });
        return projects;
      },

      projectFiles() {
        let rawFiles = this.getFormattedFiles();
        let files = [];
        for (const [key, value] of Object.entries(this.project_.files)) {
          files.push({'type': key, 'file': rawFiles[value]['originalName']});
        }
        return files;
      },
      
      collections(){
        //  return this.$store.state.files.collections;
        /* var collections = [];
        this.$store.state.files.fileList.forEach(file => {
          var col_name = this.getCollection(file);
          if (file.database === this.database_ && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        }); */
        var collections = [];
        this.project_.files.forEach(file => {
          var col_name = this.getCollection(file);
          if (file.database === this.database_ && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        });
        return collections;
      },

      databases() {
        var databases = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.database && !databases.includes(file.database)) {
            databases.push(file.database);
          }
        });
        return databases;
      },

      raw_files() {
        // let keyIs = {'database': null, 'originalName': 'key insights'};
        // return [keyIs].concat(this.F);
        this.F.forEach(x => {
          this.idList.push(x['id']);
        });
        return this.F;
      },
    
      hash() {
        ObjectHash(this.filter);
      }
    },

    watch: {
      projectID: function(val) {
        if (!!val) {
          this.raw_file = null;
          this.project_ = this.getSelectedProject();
        }
      },
      
      collection_: function(val) {
        if (!!val) {
          this.$store.state.files.fileList.forEach(file => {
          // var col_name = this.getCollection(file);
          if (file.database === this.database_ && file.originalName === this.collection_) {
              this.raw_file = file;
              this.getCount();
            }
          });
        }
      },
      
      segment: function(val) {
        
      },
      
      meta_: function(val) {
        if (!!val) {
          var fileID = this.project_.files[val];
          this.$store.state.files.fileList.forEach(file => {
          // var col_name = this.getCollection(file);
          if (file.id === fileID) {
              this.raw_file = file;
              this.collection_ = file;
              this.getCount();
            }
          });
        }
      },

      segmentID: function(val) {
        
      },

      // "$route.params.id"(id) {
      //   this.segmentID = id;
      //   console.log("Segment: ", id);
      //   this.segment = this.getSegment(id);
      //   console.log("Segment: ", this.segment);
      //   this.$store.state.files.fileList.forEach(file => {
      //     if (file.database === segment.database && file.id === segment.collection) {
      //         this.raw_file = file;
      //         this.database_ = file.database;
      //         this.getCount();
      //     }
      //   });
      // }
    },

    methods: {
      isActive(f) {
        const index = () => {
          if (key === "customers") return 0;
          if (key === "transactions") return 1;
          if (this.fileExists("transactions")) return 2;
          return 1;
        };

        return this.idList.indexOf(f) === this.tab;
      },

      getSegment(id) {
        var segment = null;
        this.$store.state.segments.segmentList.forEach(s => {
          if (s.id === id) {
            segment = s;
          }
        });
        return segment;
      },
      
      getCollection(file) {
        if (!!file.originalName) {
          if (file.originalName.indexOf(".csv") > -1) {
            return file._id;
          }
        }
        return file.originalName;
      },

      getSelectedProject() {
        var project = null;
        this.$store.state.files.projectList.forEach(p => {
          if (p.id === this.projectID) {
            project = p;
          }
        });
        return project;
      },

      toggleProjectFiles() {
        this.showProjectFiles = (!!this.showProjectFiles) ? false : true;
      },

      getCount() {
        this.collection_count = null;
        fetchInsight(`Count`, {...this.filter, collection: this.getCollection(this.raw_file), database: this.database_})
          .then(value => {
            this.collection_count = value;
          });
        // return this.collection_count;
      },

      getFormattedFiles() {
        let files = {};
        this.$store.state.files.fileList.forEach(rf => {
          var id = rf['id'];
          files[id] = rf;
        });
        return files;
      },

      abbreviateNumber(number, precision, swap=false) {
        var SI_SYMBOL = swap ?  ["", "K", "M", "G", "T", "P", "E"] : ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number, precision)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(1) + suffix;
      },

      formatDate(date) {
        return moment(date).fromNow();
      }
    },
  };
</script>

<style scoped>

</style>
